module.exports = __webpack_public_path__ + "static/media/ekspozytory_01_C.1fa5c60d.png";